export function getEnvironment() {
  const cookie = document.cookie;
  let cookieValue = "";
  if (cookie && cookie !== "") {
    const cookies = cookie.split(";");
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < cookies.length; i += 1) {
      const t = cookies[i].trim();
      if (t.substring(0, 6) === "stage=") {
        cookieValue = decodeURIComponent(t.substring(6));
        break;
      }
    }
  }
  return cookieValue && cookieValue.toLowerCase();
}

export function getQueryParam(q) {
  // return (window.location.search.match(new RegExp('[?&]' + q + '=([^&]+)')) || [null])[1];
  let result = {},
    queryString = location.search.slice(1),
    re = /([^&=]+)=([^&]*)/g,
    m;

  while ((m = re.exec(queryString))) {
    result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
  }

  return result[q];
}
export function getRedirectQueryParam() {
  let value = getQueryParam("redirect") || "";

  if (value.startsWith("%")) {
    value = decodeURIComponent(value);
  }

  if (
    value &&
    value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.includes("javascript") &&
    !value.startsWith("data:")
  ) {
    // redirect param should be always relative; if it doesnt start with / omit it.
    return value;
  } else {
    return null;
  }
}

// function isvalidURL(str) {
//   const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
//     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
//     '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
//     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
//     '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
//     '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
//   return !!pattern.test(str);
// }

export function addStyleTag(css) {
  let styles = `html {font-family: ${css.font};}.primary-color {color:${css.primaryText} !important;}.secondary-color {color:${css.secondaryText} !important;}.primary-bg-color {background-color:${css.primaryBg} !important;}.secondary-bg-color {background-color:${css.secondaryBg} !important;}.mirakl-bg-color {background-color:${css.mirakl} !important;}.text-black {color:${css.blackText} !important;}.text-light-grey {color:${css.lightGreyText} !important;}.text-grey {color:${css.greyText} !important;}.text-dark-grey {color:${css.darkGreyText} !important;}.text-white {color:${css.whiteText} !important;}`;

  if (!!css.customStyles) {
    styles += css.customStyles;
  }
  const ele = document.createElement("style");
  ele.type = "text/css";

  if (ele.styleSheet) {
    ele.styleSheet.cssText = styles;
  } else {
    ele.appendChild(document.createTextNode(styles));
  }
  document.getElementsByTagName("head")[0].appendChild(ele);

  //add link tag for font styles
  const head = document.getElementsByTagName("HEAD")[0];
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = css.fontPath;
  head.appendChild(link);
}

export function changeFavIcon(url) {
  var link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = url;
  document.getElementsByTagName("head")[0].appendChild(link);
}

export const getCurrentStage = () => {
  const cookie = document.cookie;
  let cookieValue = null;
  if (cookie && cookie !== "") {
    const cookies = cookie.split(";");
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < cookies.length; i += 1) {
      const t = cookies[i].trim();
      if (t.substring(0, 6) === "stage=") {
        cookieValue = decodeURIComponent(t.substring(6));
        break;
      }
    }
    return cookieValue && cookieValue.toLowerCase();
  } else {
    return "";
  }
};
